import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const OWNER_EMAIL = "andrea.bazzarello@ptkserv.it";

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Response interceptor: redirect a /maintenance su 503 maintenance
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const data = err?.response?.data;
    const reqUrl = err?.config?.url || "";
    const isMaintenance503 =
      status === 503 &&
      (data?.maintenance === true ||
        (typeof data?.detail === "object" && data?.detail?.maintenance === true));
    // Skip redirect se la request è verso il login: il form Login gestisce inline
    const isLoginRequest = reqUrl.includes("/auth/login");
    if (isMaintenance503 && !isLoginRequest) {
      const path = window.location.pathname;
      // Skip redirect se già su /maintenance o /login
      if (path !== "/maintenance" && path !== "/login") {
        window.location.assign("/maintenance");
      }
    }
    return Promise.reject(err);
  }
);

export { OWNER_EMAIL };

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
